import { Injectable } from '@angular/core';
import { ZuperDrawerComponent } from './zuper-drawer.component';

@Injectable({
    providedIn: 'root'
})
export class ZuperDrawerService {
    private _componentRegistry: Map<string, ZuperDrawerComponent> = new Map<string, ZuperDrawerComponent>();

    /**
     * Constructor
     */
    constructor() {
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Register drawer component
     *
     * @param name
     * @param component
     */
    registerComponent(name: string, component: ZuperDrawerComponent): void {
        this._componentRegistry.set(name, component);
    }

    /**
     * Deregister drawer component
     *
     * @param name
     */
    deregisterComponent(name: string): void {
        this._componentRegistry.delete(name);
    }

    /**
     * Get drawer component from the registry
     *
     * @param name
     */
    getComponent(name: string): ZuperDrawerComponent | undefined {
        return this._componentRegistry.get(name);
    }
}
